module.exports = __webpack_public_path__ + "img/glyphs.3a474ee.svg";